<template>
  <div>
    <page-header
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
      :has-return="true"
      @onReturn="() => $router.back()"
    />
    <div class="row">
      <div class="col">
        <filter-manager
          ref="filterRef"
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync pr-2"
          search-text=""
          search-container-class="d-flex align-items-center justify-content-end"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onProcessHandler"
        >
          <div class="col d-flex justify-content-end align-items-center">
            <dropdown
              icon="fas fa-print"
              :items="reportOptions"
              title="Seleccione"
            />
          </div>
        </filter-manager>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import Dropdown from 'dropdown'
import AcademicYearServices from '@/services/api/academicyear.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js'

export default {
  name: 'RpProviderBillingStatusIndicatorMain',
  components: {
    PageHeader,
    FilterManager,
    Dropdown,
  },
  mixins: [alertMixin],
  data: () => ({
    model: {
      search: {
        filters: {
          academicYear: null,
          companyType: { id: null, name: 'Todos' },
        },
        collections: {
          academicYears: [],
          companyTypes: [
            { id: null, name: 'Todos' },
            { id: 5,    name: 'Asistente de Servicio' },
            { id: 2,    name: 'Compañía' },
          ],
        },
      },
    },
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Indicador De Estados De Facturas De Proveedores RP',
        icon: 'fas fa-file-invoice-dollar',
        routes: ['Inicio', 'Dashboard', 'Indicador De Estados De Facturas De Proveedores RP'],
      }
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          class: 'col-12 col-md-4',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
        },
        {
          name: 'companyType',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Tipo de Proveedor',
          placeholder: 'Seleccionar',
          class: 'col-12 col-md-4',
          clearable: false,
          options: this.model.search.collections.companyTypes,
          value: this.model.search.filters.companyType,
        },
      ]
    },
    reportOptions() {
      return [
        {
          label: 'Excel',
          icon: 'fas fa-print text-green',
          class: 'pr-1',
          visible: true,
          click: () => this.onProcessHandler(false),
        },
        {
          label: 'PDF',
          icon: 'fas fa-print text-green',
          class: 'pr-1',
          visible: true,
          click: () => this.onProcessHandler(true),
        },
      ]
    },
  },
  async mounted() {
    const { data: academicYears } = await AcademicYearServices.getCurrentYearAcademicYears()
    this.model.search.collections.academicYears = academicYears
  },
  methods: {
    async onProcessHandler(isPdfFormat) {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()
      if (!isValid) {
        this.ShowToast('Alerta', 'Favor completar la información solicitada.', 'error')
        return
      }

      const { academicYear, companyType } = this.model.search.filters
      await ReportServices.getReport('rpprovidersbillingstatusindicator', {
        academicYearId: academicYear.id,
        companyTypeId: companyType?.id ?? null,
        isPdfFormat,
      }).then((res) => DocumentServices.Download(res.data))
    },
  },
}
</script>

<style lang="scss" scoped></style>
